import type { IValidationField } from 'hooks/useValidations/types';
import * as yup from 'yup';

export default function cropMultiAccount({ label = '' }: IValidationField) {
  return yup
    .string()
    .label(label)
    .default('')
    .when('isMultiAccountRequired', {
      is: (val: boolean) => val,
      then: (schema) => schema.required(),

      otherwise: (schema) => schema,
    });
}
